import { FC } from "react";
import { PhoneDTO } from "../../../domain/models/dto/PhoneDTO";
import { useTranslation } from "react-i18next";
import {
    getTelegramContactLink,
    getViberContactLink,
    getWhatsAppContactLink,
} from "../../../tools/ContactLinkTools";

interface UserProfileContactsCardProps {
    phones: PhoneDTO[];
    telegram: string;
}

const UserProfileContactsCard: FC<UserProfileContactsCardProps> = (props) => {
    const { t } = useTranslation();
    const telegramContactLink = getTelegramContactLink(props.telegram);
    const hasContactInfo = !!(props.phones?.length || telegramContactLink);

    return (
        <>
            {hasContactInfo && (
                <div className="flex mmax2:flex-col tmin4:items-start bg-backgroundBlock border border-backgroundButton rounded-2xl pb-4 tmax4:pb-4 pt-4 tmax4:pt-2 px-9 tmax4:px-4 max-w-[737px] di7:max-w-[582px]">
                    <p className="H20 text-textWhite mr-6 mt-2 mmax2:mb-2">{t("common.contacts")}</p>
                    <div className="flex flex-col justify-center">
                        <div className="flex flex-col items-start">
                            {props.phones?.map((phone, index) => (
                                <div
                                    key={`user-phone-${index}`}
                                    className="flex items-center justify-center mmax2:justify-start my-2 tmax4:my-[6px]"
                                >
                                    <span className="H20B dmax2:H16B text-textWhite mr-5">{phone.phone}</span>
                                    <div className="flex items-center">
                                        {phone.viber && getViberContactLink(phone.phone) && (
                                            <a href={getViberContactLink(phone.phone)!}>
                                                <img src="/images/viber.png" alt="viber" className="w-9 dmax2:w-8 mr-4" />
                                            </a>
                                        )}
                                        {phone.whatsapp && getWhatsAppContactLink(phone.phone) && (
                                            <a href={getWhatsAppContactLink(phone.phone)!} target="_blank" rel="noreferrer">
                                                <img src="/images/whatsapp.png" alt="whatsapp" className="w-9 dmax2:w-8" />
                                            </a>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                        {telegramContactLink && (
                            <a
                                href={telegramContactLink}
                                target="_blank"
                                rel="noreferrer"
                                className={`flex items-center ${props.phones?.length === 0 ? "mt-[6px]" : "mt-2"}`}
                            >
                                <span className="H20B dmax2:H16B text-textWhite mr-3 dmax2:mr-2">
                                    {t("userProfile.fields.telegramField")}
                                </span>
                                <img src="/images/telegram.png" alt="telegram" className="w-9 dmax2:w-8 mr-4" />
                            </a>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default UserProfileContactsCard;
